export const isString = (value: any) => typeof value === 'string' || value instanceof String;

export const capitalize = (str: string): string => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const stringifyValues = (obj: Record<string, any>): Record<string, string> => {
    const newObj = {} as any;
    Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'object') {
            newObj[key] = JSON.stringify(obj[key]);
        } else {
            newObj[key] = obj[key];
        }
    });
    return newObj;
};
